/* Quick-add sheet (opens from the bottom) for "Select Options" buttons,
   plus the "You may also like" row inside the cart drawer. */
(function () {
  var cfg = window.nvShop || {};
  if (!window.NvCore) return;
  var C = window.NvCore, esc = C.esc;

  /* ============================== helpers ============================== */
  function optNames(p) { return (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; }); }
  function vopts(v) { return v.options && v.options.length ? v.options : [v.option1, v.option2, v.option3].filter(function (x) { return x != null; }); }
  function values(p, i) {
    var o = p.options && p.options[i];
    if (o && o.values) return o.values.slice();
    var seen = {}, out = [];
    p.variants.forEach(function (v) { var x = vopts(v)[i]; if (!seen[x]) { seen[x] = 1; out.push(x); } });
    return out;
  }
  function same(a, b) { for (var i = 0; i < a.length; i++) if (a[i] !== b[i]) return false; return true; }
  function variantFor(p, sel) { for (var i = 0; i < p.variants.length; i++) if (same(vopts(p.variants[i]), sel)) return p.variants[i]; return null; }
  function simple(p) { return p.variants.length === 1 || (p.options && p.options.length === 1 && values(p, 0).length === 1); }

  /* ============================== sheet ============================== */
  var wrap, st = null, prevOverflow = '';

  function build() {
    if (wrap) return;
    wrap = document.createElement('div');
    wrap.className = 'nv-sheet-wrap';
    wrap.hidden = true;
    wrap.innerHTML = '<div class="nv-sheet__bg" data-close></div>' +
      '<div class="nv-sheet" role="dialog" aria-modal="true" aria-label="Choose options">' +
      '<div class="nv-sheet__grab" data-grab><span></span></div>' +
      '<button type="button" class="nv-sheet__x" data-close aria-label="Close">&times;</button>' +
      '<div class="nv-sheet__body"></div></div>';
    document.body.appendChild(wrap);
    wrap.addEventListener('click', onClick);
    wrap.addEventListener('change', onChange);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && st) close(); });

    // drag down to close
    var sheet = wrap.querySelector('.nv-sheet'), y0 = 0, dy = 0, drag = false;
    wrap.querySelector('[data-grab]').addEventListener('touchstart', function (e) { y0 = e.touches[0].clientY; dy = 0; drag = true; sheet.style.transition = 'none'; }, { passive: true });
    wrap.addEventListener('touchmove', function (e) { if (!drag) return; dy = Math.max(0, e.touches[0].clientY - y0); sheet.style.transform = 'translateY(' + dy + 'px)'; }, { passive: true });
    wrap.addEventListener('touchend', function () { if (!drag) return; drag = false; sheet.style.transition = ''; sheet.style.transform = ''; if (dy > 90) close(); }, { passive: true });
  }

  function close() {
    if (!wrap) return;
    wrap.classList.remove('is-open');
    document.body.style.overflow = prevOverflow;
    st = null;
    setTimeout(function () { if (!st) wrap.hidden = true; }, 260);
  }

  function open(handle) {
    build();
    prevOverflow = document.body.style.overflow;
    wrap.hidden = false;
    wrap.querySelector('.nv-sheet__body').innerHTML = '<div class="nv-sheet__load"><span></span><span></span><span></span></div>';
    requestAnimationFrame(function () { wrap.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
    st = { loading: true };
    C.product(handle).then(function (p) {
      if (!st) return;
      var v0 = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
      st = { p: p, sel: vopts(v0).slice(), qty: 1, busy: false, err: '' };
      render();
      var f = wrap.querySelector('.nv-chip.is-on, .nv-sheet__add'); if (f) f.focus({ preventScroll: true });
    }).catch(function () {
      wrap.querySelector('.nv-sheet__body').innerHTML = '<p class="nv-sheet__msg">Sorry, this product could not be loaded.</p><a class="nv-sheet__more" href="/products/' + esc(handle) + '">Open product page</a>';
    });
  }

  // choose a value; if that exact combination does not exist, jump to the closest real variant
  function pick(i, val) {
    var p = st.p, cur = st.sel.slice();
    cur[i] = val;
    var exact = variantFor(p, cur);
    if (exact) { st.sel = vopts(exact).slice(); return; }
    var best = null, bestScore = -1;
    p.variants.forEach(function (v) {
      var o = vopts(v); if (o[i] !== val) return;
      var score = 0; for (var j = 0; j < o.length; j++) if (j !== i && o[j] === st.sel[j]) score++;
      score = score * 2 + (v.available ? 1 : 0);
      if (score > bestScore) { best = v; bestScore = score; }
    });
    if (best) st.sel = vopts(best).slice();
  }

  function chipState(i, val) { // does a variant exist / is it buyable, given the other chosen options
    var p = st.p, exists = false, avail = false;
    p.variants.forEach(function (v) {
      var o = vopts(v); if (o[i] !== val) return;
      for (var j = 0; j < o.length; j++) if (j !== i && o[j] !== st.sel[j]) return;
      exists = true; if (v.available) avail = true;
    });
    return { exists: exists, avail: avail };
  }
  function imageFor(i, val) {
    var p = st.p;
    for (var k = 0; k < p.variants.length; k++) {
      var v = p.variants[k];
      if (vopts(v)[i] === val && v.featured_image && v.featured_image.src) return v.featured_image.src;
    }
    return '';
  }

  function optionHtml(i) {
    var p = st.p, name = optNames(p)[i] || 'Option', vals = values(p, i);
    var html = '<div class="nv-opt" data-i="' + i + '"><p class="nv-opt__name">' + esc(name) + ': <b>' + esc(st.sel[i]) + '</b></p>';
    if (vals.length > 12) { // many values: native picker, works great on phones
      html += '<select class="nv-opt__select" data-select="' + i + '" aria-label="' + esc(name) + '">';
      vals.forEach(function (val) {
        var s = chipState(i, val);
        html += '<option value="' + esc(val) + '"' + (val === st.sel[i] ? ' selected' : '') + '>' + esc(val) + (s.exists && !s.avail ? ' (sold out)' : '') + '</option>';
      });
      return html + '</select></div>';
    }
    var imgs = vals.map(function (val) { return imageFor(i, val); });
    var withImg = imgs.every(Boolean) && imgs.filter(function (s, k) { return imgs.indexOf(s) === k; }).length > 1;
    html += '<div class="nv-chips' + (withImg ? ' nv-chips--img' : '') + (vals.length > 6 ? ' nv-chips--many' : '') + '">';
    vals.forEach(function (val, k) {
      var s = chipState(i, val), cls = 'nv-chip' + (val === st.sel[i] ? ' is-on' : '') + (s.exists && s.avail ? '' : ' is-out');
      html += '<button type="button" class="' + cls + '" data-pick="' + i + '" data-val="' + esc(val) + '">' +
        (withImg ? '<img src="' + esc(C.img(imgs[k], 96)) + '" alt="" width="44" height="44" loading="lazy">' : '') +
        '<span>' + esc(val) + '</span></button>';
    });
    return html + '</div></div>';
  }

  function render() {
    var p = st.p, v = variantFor(p, st.sel), body = wrap.querySelector('.nv-sheet__body');
    var simpleP = simple(p);
    var src = (v && v.featured_image && v.featured_image.src) || p.featured_image || (p.images && p.images[0]) || '';
    var price = v ? v.price : p.price, was = v && v.compare_at_price > v.price ? v.compare_at_price : 0;
    var pct = was ? Math.round((1 - price / was) * 100) : 0;
    var opts = '';
    if (!simpleP) for (var i = 0; i < p.options.length; i++) opts += optionHtml(i);
    var label = !v ? 'Select options' : (!v.available ? 'Sold out' : 'Add to cart');
    body.innerHTML =
      '<div class="nv-sheet__top">' +
        (src ? '<img class="nv-sheet__img" src="' + esc(C.img(src, 240)) + '" alt="' + esc(p.title) + '" width="96" height="96">' : '') +
        '<div class="nv-sheet__info"><p class="nv-sheet__title">' + esc(p.title) + '</p>' +
        '<p class="nv-sheet__price"><b>' + C.money(price) + '</b>' + (was ? ' <s>' + C.money(was) + '</s> <em>' + pct + '% off</em>' : '') + '</p></div>' +
      '</div>' +
      '<div class="nv-sheet__opts">' + opts + '</div>' +
      '<div class="nv-sheet__qty"><span>Quantity</span><div class="nv-qty">' +
        '<button type="button" data-qty="-1" aria-label="Decrease quantity"' + (st.qty <= 1 ? ' disabled' : '') + '>&minus;</button>' +
        '<output>' + st.qty + '</output>' +
        '<button type="button" data-qty="1" aria-label="Increase quantity"' + (st.qty >= 10 ? ' disabled' : '') + '>+</button></div></div>' +
      (st.err ? '<p class="nv-sheet__err" role="alert">' + esc(st.err) + '</p>' : '') +
      '<button type="button" class="nv-sheet__add" data-add' + (!v || !v.available || st.busy ? ' disabled' : '') + '>' + (st.busy ? 'Adding...' : label) + '</button>' +
      '<a class="nv-sheet__more" href="/products/' + esc(p.handle) + '">View full details</a>';
  }

  function onClick(e) {
    var t = e.target;
    if (t.closest('[data-close]')) { close(); return; }
    var chip = t.closest('[data-pick]');
    if (chip && st && st.p) { pick(Number(chip.getAttribute('data-pick')), chip.getAttribute('data-val')); st.err = ''; render(); return; }
    var q = t.closest('[data-qty]');
    if (q && st && st.p) { st.qty = Math.max(1, Math.min(10, st.qty + Number(q.getAttribute('data-qty')))); render(); return; }
    if (t.closest('[data-add]') && st && st.p && !st.busy) {
      var v = variantFor(st.p, st.sel); if (!v || !v.available) return;
      st.busy = true; st.err = ''; render();
      C.add(v.id, st.qty).then(function () {
        close();
        C.refreshCart();
      }).catch(function (err) {
        if (!st) return; st.busy = false; st.err = err.message; render();
      });
    }
  }
  function onChange(e) {
    var s = e.target.closest && e.target.closest('[data-select]');
    if (s && st && st.p) { pick(Number(s.getAttribute('data-select')), s.value); st.err = ''; render(); }
  }

  window.NvQuick = { open: open, close: close, isSimple: simple };

  /* ============== "Select Options" buttons open the sheet ============== */
  if (cfg.quickAdd !== false) {
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var el = e.target.closest && e.target.closest('a, button');
      if (!el || el.closest('product-info, cart-drawer, .nv-sheet, header, footer')) return;
      var marked = el.hasAttribute('data-nv-options');
      var texty = /^\s*(select|choose)\s+options?\s*$/i.test(el.textContent || '');
      if (!marked && !texty) return;
      var handle = el.tagName === 'A' ? C.handleOf(el.href) : null;
      if (!handle) { var hit = C.findCard(el); handle = hit && C.handleOf(hit.link.href); }
      if (!handle) return;
      e.preventDefault(); e.stopPropagation();
      open(handle);
    }, true);
  }

  /* ============== cart drawer: "You may also like" ============== */
  function recKey(id) { return 'nv_reco_' + id; }
  function getRecs(id) {
    try { var c = JSON.parse(sessionStorage.getItem(recKey(id)) || 'null'); if (c && Date.now() - c.t < 10 * 60000) return Promise.resolve(c.p); } catch (e) { /* ignore */ }
    var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    return fetch(root + 'recommendations/products.json?product_id=' + id + '&limit=10&intent=related')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        var list = (d.products || []).map(function (p) { return { id: p.id, handle: p.handle, title: p.title, url: p.url, type: p.type || '', tags: p.tags || [], available: p.available, price: p.price, compare_at_price: p.compare_at_price, image: p.featured_image || '', variants: (p.variants || []).map(function (v) { return { id: v.id, available: v.available }; }) }; });
        try { sessionStorage.setItem(recKey(id), JSON.stringify({ t: Date.now(), p: list })); } catch (e) { /* ignore */ }
        return list;
      }).catch(function () { return []; });
  }
  // products of a collection (public endpoint), mapped to the same shape as the recommendation list
  function getCollection(handle) {
    var key = 'nv_col_' + handle;
    try { var c = JSON.parse(sessionStorage.getItem(key) || 'null'); if (c && Date.now() - c.t < 10 * 60000) return Promise.resolve(c.p); } catch (e) { /* ignore */ }
    var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    return fetch(root + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=60')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        var list = (d.products || []).map(function (p) {
          var v0 = (p.variants || [])[0] || {};
          var cmp = Math.round(parseFloat(v0.compare_at_price || 0) * 100) || 0;
          return { id: p.id, handle: p.handle, title: p.title, url: root + 'products/' + p.handle, type: p.product_type || '', tags: p.tags || [],
            available: (p.variants || []).some(function (v) { return v.available; }),
            price: Math.round(parseFloat(v0.price || 0) * 100), compare_at_price: cmp,
            image: (p.images && p.images[0] && p.images[0].src) || '',
            variants: (p.variants || []).map(function (v) { return { id: v.id, available: v.available }; }) };
        });
        try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), p: list })); } catch (e) { /* ignore */ }
        return list;
      }).catch(function () { return []; });
  }
  function relevance(p, seeds) {
    var best = 0;
    seeds.forEach(function (s) {
      var sc = 0;
      if (s.type && p.type && s.type === p.type) sc += 3;
      var tags = (s.tags || []).map(function (t) { return String(t).toLowerCase(); });
      (p.tags || []).forEach(function (t) { if (tags.indexOf(String(t).toLowerCase()) > -1) sc += 1; });
      if (sc > best) best = sc;
    });
    return best;
  }
  function fillReco(box) {
    if (box.__nvDone) return; box.__nvDone = true;
    var seeds = []; try { seeds = JSON.parse(box.querySelector('script[type="application/json"]').textContent || '[]'); } catch (e) { /* ignore */ }
    var inCart = (box.getAttribute('data-cart') || '').split(',').filter(Boolean);
    var addons = (box.getAttribute('data-addons') || '').split(',').filter(Boolean);
    var fsLeft = parseInt(box.getAttribute('data-fs-left'), 10) || 0;   // paise still needed for free delivery (0 = already free / bar off)
    if (!seeds.length) return;
    Promise.all(seeds.slice(0, 2).map(function (s) { return getRecs(s.id); })).then(function (lists) {
      // free delivery: if the related list has too few items that can close the gap, top it up from the same collection
      var unlockers = 0;
      lists.forEach(function (l) { l.forEach(function (p) { if (fsLeft > 0 && p.available && p.price >= fsLeft) unlockers++; }); });
      if (fsLeft > 0 && unlockers < 3) {
        var cols = seeds.slice(0, 2).map(function (s) { return s.col; }).filter(function (c, i, a) { return c && a.indexOf(c) === i; });
        return Promise.all(cols.map(getCollection)).then(function (extra) {
          extra.forEach(function (l) { l.forEach(function (p) { p.fromCol = 1; }); });
          return lists.concat(extra);
        });
      }
      return lists;
    }).then(function (lists) {
      var merged = [], seen = {};
      var maxLen = 0; lists.forEach(function (l) { if (l.length > maxLen) maxLen = l.length; });
      for (var k = 0; k < maxLen; k++) lists.forEach(function (l) { var p = l[k]; if (p && !seen[p.id]) { seen[p.id] = 1; merged.push(p); } });
      merged = merged.filter(function (p) {
        if (!p.available || inCart.indexOf(String(p.id)) > -1) return false;
        return !p.variants.some(function (v) { return addons.indexOf(String(v.id)) > -1; }); // never suggest the service add-ons as products
      });
      // keep only products that really match what is in the cart (same type / shared tags); fall back to the store's own "related" order
      var scored = merged.map(function (p, idx) { return { p: p, s: relevance(p, seeds) + (p.fromCol ? 1 : 0), idx: idx }; });
      var matched = scored.filter(function (x) { return x.s > 0; }).sort(function (a, b) { return b.s - a.s || a.idx - b.idx; });
      var list = (matched.length >= 2 ? matched : scored).slice(0, 8).map(function (x) { return x.p; });
      if (fsLeft > 0) {
        // items whose price alone gets the cart to free delivery come first (cheapest that does it first), then the rest
        var pool = (matched.length >= 2 ? matched : scored).map(function (x) { return x.p; });
        var unlock = pool.filter(function (p) { return p.price >= fsLeft; }).sort(function (a, b) {
          var ra = a.price <= fsLeft * 3 ? 0 : 1, rb = b.price <= fsLeft * 3 ? 0 : 1;      // prefer items up to ~3x the missing amount
          return ra - rb || a.price - b.price;
        });
        var rest = pool.filter(function (p) { return p.price < fsLeft; });
        list = unlock.slice(0, 4).concat(rest).slice(0, 8);
        var t = box.querySelector('.nv-reco__title');
        if (t && unlock.length) t.textContent = 'Add one of these to unlock FREE delivery';
      }
      if (!list.length) return;
      box.querySelector('.nv-reco__row').innerHTML = list.map(function (p) {
        var buyable = p.variants.filter(function (v) { return v.available; });
        var single = p.variants.length === 1;
        var unlocks = fsLeft > 0 && p.price >= fsLeft;
        return '<div class="nv-reco__card' + (unlocks ? ' is-unlock' : '') + '">' + (unlocks ? '<span class="nv-reco__flag">Free delivery</span>' : '') + '<a class="nv-reco__img" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(C.img(p.image, 240)) + '" alt="" width="120" height="120" loading="lazy">' : '') + '</a>' +
          '<a class="nv-reco__t" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<span class="nv-reco__p">' + C.money(p.price) + (p.compare_at_price > p.price ? ' <s>' + C.money(p.compare_at_price) + '</s>' : '') + '</span>' +
          '<button type="button" class="nv-reco__add" data-reco-add data-handle="' + esc(p.handle) + '"' + (single && buyable[0] ? ' data-vid="' + buyable[0].id + '"' : '') + '>' + (single ? 'Add' : 'Options') + '</button></div>';
      }).join('');
      box.hidden = false;
    });
  }
  function scanReco() { document.querySelectorAll('[data-nv-reco]').forEach(fillReco); }
  if (cfg.reco !== false) {
    var rt;
    var obs = new MutationObserver(function () { clearTimeout(rt); rt = setTimeout(scanReco, 120); });
    function bootReco() { scanReco(); obs.observe(document.body, { childList: true, subtree: true }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootReco); else bootReco();
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-reco-add]');
      if (!b) return;
      e.preventDefault();
      var vid = b.getAttribute('data-vid');
      if (!vid) { open(b.getAttribute('data-handle')); return; }
      if (b.disabled) return;
      b.disabled = true; b.textContent = 'Adding...';
      C.add(vid, 1).then(function () { C.refreshCart(); }).catch(function (err) { b.disabled = false; b.textContent = 'Add'; C.toast(esc(err.message)); });
    });
  }
})();
